import React from 'react'
import PersonalizationComponent from '../Components/app/dashboard/dashboard-personalization/personalizationComponent'

function DashboardPersonalization(props) {
  return <PersonalizationComponent public={props.public || false}/>
}

export default DashboardPersonalization;